/* eslint-disable max-lines-per-function */
import React from 'react'
import { authFetch } from '~/services/fetch'

export async function getDispatchByHour(
  agencyId,
  deviceId,
  operationId,
  dispatchGroupId,
  categoryIds,
  typeIds,
  subtypeIds,
  startDate,
  endDate,
  payload,
  consummated,
  statusIds,
  cityIds,
  groupSetId,
  location,
  operationUnitId,
  closedStatusClassId,
  closedStatusId,
  qualifierOptions,
  phone,
  requester,
  userId,
  districtIds,
  geographicAreas,
  startTime?,
  endTime?,
) {
  try {
    const { data } = await authFetch({
      url: '/statistics/dispatches-by-hours',
      method: 'POST',
      data: {
        agencyId: agencyId,
        deviceId: deviceId,
        operationId: operationId,
        dispatchGroupIds: dispatchGroupId,
        categoryIds: categoryIds,
        typeIds: typeIds,
        subtypeIds: subtypeIds,
        startDate: startDate,
        finishDate: endDate,
        excludeClosed: payload.exludeClosed,
        withSolvedThirdParty: payload.withSolvedThirdParty,
        consummated: consummated,
        statusIds: statusIds,
        cityIds: cityIds,
        districtIds: districtIds,
        groupSetId: groupSetId,
        location: location,
        operationUnitId: operationUnitId,
        closedStatusClassId: closedStatusClassId,
        closedStatusId: closedStatusId,
        qualifierOptions: qualifierOptions,
        phone: phone,
        geographicAreas: geographicAreas ?? [],
        name: requester,
        userId: userId,
        startTime: startTime,
        endTime: endTime,
      },
    })

    return data
  } catch (error) {
    throw error
  }
}

export async function getDispatchByWeekday(
  agencyId,
  deviceId,
  operationId,
  dispatchGroupId,
  categoryIds,
  typeIds,
  subtypeIds,
  startDate,
  endDate,
  payload,
  consummated,
  statusIds,
  cityIds,
  groupSetId,
  location,
  operationUnitId,
  closedStatusClassId,
  closedStatusId,
  qualifierOptions,
  phone,
  requester,
  userId,
  districtIds,
  geographicAreas,
  startTime?,
  endTime?,
) {
  try {
    const { data } = await authFetch({
      url: '/statistics/dispatches-by-weekday',
      method: 'POST',
      data: {
        agencyId: agencyId,
        deviceId: deviceId,
        operationId: operationId,
        dispatchGroupIds: dispatchGroupId,
        categoryIds: categoryIds,
        typeIds: typeIds,
        subtypeIds: subtypeIds,
        startDate: startDate,
        finishDate: endDate,
        excludeClosed: payload.exludeClosed,
        withSolvedThirdParty: payload.withSolvedThirdParty,
        consummated: consummated,
        statusIds: statusIds,
        cityIds: cityIds,
        districtIds: districtIds,
        groupSetId: groupSetId,
        location: location,
        operationUnitId: operationUnitId,
        closedStatusClassId: closedStatusClassId,
        closedStatusId: closedStatusId,
        qualifierOptions: qualifierOptions,
        phone: phone,
        geographicAreas: geographicAreas ?? [],
        name: requester,
        userId: userId,
        startTime: startTime,
        endTime: endTime,
      },
    })

    return data
  } catch (error) {
    throw error
  }
}

export async function getDispatchByWeekdayAndHour(
  agencyId,
  deviceId,
  operationId,
  dispatchGroupId,
  categoryIds,
  typeIds,
  subtypeIds,
  startDate,
  endDate,
  payload,
  consummated,
  statusIds,
  cityIds,
  groupSetId,
  location,
  operationUnitId,
  closedStatusClassId,
  closedStatusId,
  qualifierOptions,
  phone,
  requester,
  userId,
  districtIds,
  geographicAreas,
  startTime?,
  endTime?,
) {
  try {
    const { data } = await authFetch({
      url: '/statistics/dispatches-by-weekday-and-hours',
      method: 'POST',
      data: {
        agencyId: agencyId,
        deviceId: deviceId,
        operationId: operationId,
        dispatchGroupIds: dispatchGroupId,
        categoryIds: categoryIds,
        typeIds: typeIds,
        subtypeIds: subtypeIds,
        startDate: startDate,
        finishDate: endDate,
        excludeClosed: payload.exludeClosed,
        withSolvedThirdParty: payload.withSolvedThirdParty,
        consummated: consummated,
        statusIds: statusIds,
        cityIds: cityIds,
        districtIds: districtIds,
        groupSetId: groupSetId,
        location: location,
        operationUnitId: operationUnitId,
        closedStatusClassId: closedStatusClassId,
        closedStatusId: closedStatusId,
        qualifierOptions: qualifierOptions,
        phone: phone,
        geographicAreas: geographicAreas ?? [],
        name: requester,
        userId: userId,
        startTime: startTime,
        endTime: endTime,
      },
    })

    return data
  } catch (error) {
    throw error
  }
}
